/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum CONNECTIVE_ATTRS_LIST {
  OPERATOR = "operator",
}
